import { render, staticRenderFns } from "./StartSieItem.vue?vue&type=template&id=6ada0f22&scoped=true&"
import script from "./StartSieItem.vue?vue&type=script&lang=ts&"
export * from "./StartSieItem.vue?vue&type=script&lang=ts&"
import style0 from "./StartSieItem.vue?vue&type=style&index=0&id=6ada0f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ada0f22",
  null
  
)

export default component.exports